import apiClient from "../../../api/apiClient";

export const getCalibrationCertificatesByIdsApi = async (
  calibrationIds: string[],
  tenantId: string,
) => {
  const response = await apiClient.post(
    `/calibration-certificates/by-ids?tenantId=${tenantId}`,
    {
      calibrationIds,
    },
  );

  return response.data;
};

// ================= GET ALL =================
export const getCalibrationCertificatesApi =
  async (
    page: number,
    pageSize: number,
    search: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        "/calibration-certificates",
        {
          params: {
            pageNumber: page,
            pageSize,
            search,
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= GET BY ID =================
export const getCalibrationCertificateByIdApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        `/calibration-certificates/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= CREATE =================
export const createCalibrationCertificateApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.post(
        "/calibration-certificates",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= UPDATE =================
export const updateCalibrationCertificateApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.put(
        "/calibration-certificates",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= DELETE =================
export const deleteCalibrationCertificateApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.delete(
        `/calibration-certificates/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };